module.exports = __webpack_public_path__ + "static/img/bg-3.cbc394b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/bnaner/bg-3.png
// module id = sJp6
// module chunks = 0